import React, { Component } from 'react';

import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux'
import * as api from '../api/api'
import * as actions from '../actions'

class Logout extends Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const obj = {}
    obj.accessToken = ''
    this.props.userLogout(obj)
    this.props.history.push('/portal/signin')
    /*
    api
      .signout(this.props.accessToken, this.props.client, this.props.uid)
      .then((result) => {
        // console.log(result)
        const { success, errors } = result
        if (success) {
          // console.log('Logging out')
          const obj = {}
          obj.accessToken = ''
          obj.client = ''
          obj.uid = ''
          this.props.logout(obj)
          this.props.history.push('/portal/')
        } else {
          this.setState({ errorMsg: JSON.stringify(errors) })
        }
      })
      .catch((err) => {
        // console.log(`err = ${JSON.stringify(err)}`)
        this.setState({ errorMsg: err.stack })
      })*/
  }

  render() {
    return (
      <div></div>
    );
  }
}

function mapStateToProps() {
  return {}
}

function mapDispatchToProps(dispatch) {
  return {
    userLogout: data => dispatch(actions.userLogout(data)),
    adminLogout: data => dispatch(actions.adminLogout(data)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Logout)


// WEBPACK FOOTER //
// ./src/views/Logout.jsx